import { List, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { AddCircleOutline } from "@mui/icons-material";
import { AppDialog } from "./AppDialog";
import { AppSpinner } from "./AppSpinner";
import { SimpleAutoComplete } from "./SimpleAutoComplete";
import Project from "../models/Project";
import { EnsolversOpsUser } from "../models/EnsolversOpsUser";
import { Dispatch, SetStateAction } from "react";
import AutoCompleteUIDTO from "../dto/AutoCompleteUIDTO";
import Grid from "@mui/material/Grid/Grid";
import ListItem from "@mui/material/ListItem/ListItem";
import IconButton from "@mui/material/IconButton/IconButton";

interface Props {
  editProjectManager: Project | undefined;
  handleCloseManagerModal: () => void;
  managerList: EnsolversOpsUser[] | undefined;
  onAddManager: () => void;
  onRemoveManager: (userExternalId: string) => void;
  isUpdating?: boolean;
  setSearchManager: Dispatch<SetStateAction<AutoCompleteUIDTO | undefined>>;
  searchManager: AutoCompleteUIDTO | undefined;
  userNames: AutoCompleteUIDTO[];
}

export const ModalAddRemovePM = ({
  editProjectManager,
  handleCloseManagerModal,
  managerList,
  onAddManager,
  onRemoveManager,
  isUpdating = false,
  setSearchManager,
  searchManager,
  userNames,
}: Props) => {
  return (
    <AppDialog
      open={!!editProjectManager}
      onClose={handleCloseManagerModal}
      title="Assigned Managers"
      hideCancel
      content={
        <>
          <Grid container display="flex" alignItems="center" justifyItems="center">
            <Grid item xs={12} sx={{ marginBottom: "2em" }}>
              {managerList === undefined ? (
                <AppSpinner />
              ) : managerList.length === 0 ? (
                <Typography>There is no assigned managers.</Typography>
              ) : (
                <List>
                  {managerList.map((item, itemIndex) => (
                    <ListItem
                      key={itemIndex}
                      secondaryAction={
                        <IconButton
                          edge="end"
                          aria-label="delete"
                          disabled={isUpdating}
                          onClick={() => item.externalId && onRemoveManager(item.externalId)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      }
                    >{`• ${item.firstName} ${item.lastName}`}</ListItem>
                  ))}
                </List>
              )}
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={10}>
              <SimpleAutoComplete
                label="Add a new manager"
                items={userNames}
                value={searchManager!}
                onChange={(newValue) => setSearchManager(newValue)}
                disablePortal={false}
              />
            </Grid>
            <Grid item xs={2}>
              <IconButton
                disabled={isUpdating}
                onClick={onAddManager}
                size="large"
                sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}
              >
                <AddCircleOutline />
              </IconButton>
            </Grid>
          </Grid>
        </>
      }
      buttons={[{ label: "Close", onClick: () => handleCloseManagerModal() }]}
    />
  );
};
